import { Link } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';
import type { TKey } from '~/lib/i18n-locales';
import { faqsData } from '~/modules/marketing/marketing-config';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '~/modules/ui/accordion';

export function FAQ() {
  const { t } = useTranslation();
  return (
    <Accordion className="mx-auto max-w-3xl">
      {faqsData.map((faq, index) => {
        const question = `about:faq.question_${index + 1}` as TKey;
        const answer = `about:faq.answer_${index + 1}` as TKey;
        const isExternal = faq.link?.startsWith('http');

        return (
          <AccordionItem key={faq.id} value={faq.id}>
            <AccordionTrigger className="px-3 text-xl">{t(question)}</AccordionTrigger>
            <AccordionContent className="px-3 pb-8 text-lg">
              <Trans
                t={t}
                i18nKey={answer as never}
                components={{
                  Link: (
                    <Link
                      to={faq.link}
                      target={isExternal ? '_blank' : undefined}
                      rel={isExternal ? 'noreferrer' : undefined}
                      className="link-inline"
                    />
                  ),
                }}
              />
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
